import { loadStateData } from './../Storage';
import { allMenuItems } from '../Config/data';
import doRecursive from '../../utils/recursive';
import { PROCESSOR_CHC, PROCESSOR_NAMES, PAYMENT_METHOD_TYPE_ACH } from '../../constants';



const getPureActions = (actions, { aliases = {} } = {}) =>
  actions.reduce((result, item) => (aliases[item] ? [...result, ...aliases[item]] : [...result, item]), []);

export const AccessMerchant = (merchantId) => {
  const state = loadStateData() || {};
  const merchants = state?.profile?.merchants ?? [];
  const accessScopes = state?.profile?.accessScopes ?? {};
  const merchant = merchants.find(({ id }) => id === merchantId) || {};
  const { userAccessScopes = {} } = merchant;

  return {
    can: (action, scope) => {
      const actions = Array.isArray(action) ? action : [action];
      const allUserScopeActions = getPureActions(userAccessScopes[scope] || [], accessScopes[scope] || {});

      return getPureActions(actions, accessScopes[scope] || {}).every((item) => allUserScopeActions.includes(item));
    },
    canDoAchTransfer: () => {
      const { availableTranTypes = [], settings: { processors = {} } = {} } = merchant;
      const achProcName = PROCESSOR_NAMES[PROCESSOR_CHC];

      return (
        availableTranTypes.includes(PAYMENT_METHOD_TYPE_ACH) &&
        processors[achProcName] &&
        Object.keys(processors[achProcName]).length > 0
      );
    },
    hasFeature: (featureId) => {
      if (!merchant.id) return false;

      // eslint-disable-next-line no-use-before-define
      const menuItem = doRecursive('children')(allMenuItems(hasSomeAccess)).find(({ id }) => id === featureId);
      if (!menuItem) return false;

      const { isShow } = menuItem;

      if (typeof isShow === 'boolean') return isShow;

      if (typeof isShow === 'function' && typeof isShow.featureChecker === 'function') {
        return menuItem.isShow.featureChecker(merchant, merchants);
      }

      return true;
    }
  };
};

export const hasAccess = ({ merchantId, accessRules }) => {
  const accessMerchant = AccessMerchant(merchantId);

  return !accessRules || Object.entries(accessRules).every(([scope, actions]) => accessMerchant.can(actions, scope));
};

export const hasAnyUserAccess = ({ merchants, accessRules }) =>
  merchants.some(
    (merchant) =>
      !accessRules ||
      Object.entries(accessRules).some(([scope, actions]) => AccessMerchant(merchant.id).can(actions, scope))
  );

export const getPermittedScopes = (data, merchantId, accessMerchant) => {
  const nextAccessMerchant = !accessMerchant ? AccessMerchant(merchantId) : accessMerchant;

  return data.filter(
    ({ accessRules }) =>
      !accessRules || Object.entries(accessRules).every(([scope, actions]) => nextAccessMerchant.can(actions, scope))
  );
};


export const hasSomeAccess = ({ merchantId, accessRules }) =>
  !accessRules ||
  Object.entries(accessRules).some(([scope, actions]) => AccessMerchant(merchantId).can(actions, scope));

export default AccessMerchant;
